import Vue from 'vue'
import Vuex from 'vuex'
import server from './modules/server'
import data from './modules/data'


/* Vuex状态管理器  帮助文档：https://vuex.vuejs.org/zh-cn/installation.html
-------------------------------------------------------------------------------------------*/
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    server,
    data
  },
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js